export const closeButtonId = 'info-tooltip-close-btn';
